// Shared layout constants.
//
// Dependency-free on purpose: these used to be exported from the component and route
// files that consume them (NavigationPanel, (Library)/library), which produced require
// cycles with the hooks and components that need the numbers.
import { SPACING } from '../config/designSystem/Spacing';

export const DRAWER_WIDTH = 272;
export const marginHorizontalLibrary = SPACING['sp-16'];
